import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import BoardContent from "./BoardContent";
import { boardService } from '../../service/firebase/boardService';
import type { Board } from '../../type';

const BoardPage = () => {
  const queryClient = useQueryClient();

  // 게시판 목록 조회
  const { data: boards = [], isLoading, error } = useQuery({
    queryKey: ['boards'],
    queryFn: () => boardService.getAll(),
  });

  // 게시판 추가
  const addBoardMutation = useMutation({
    mutationFn: (board: Board) => boardService.create(board),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['boards'] });
    },
  });

  // 게시판 수정
  const updateBoardMutation = useMutation({
    mutationFn: (board: Board) => boardService.update(board.boardId, board),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['boards'] });
    },
  });

  // 게시판 삭제
  const deleteBoardMutation = useMutation({
    mutationFn: (boardId: string) => boardService.delete(boardId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['boards'] });
    },
  });

  const handleAddBoard = async (board: Board) => {
    await addBoardMutation.mutateAsync(board);
  };

  const handleUpdateBoard = async (board: Board) => {
    await updateBoardMutation.mutateAsync(board);
  };

  const handleDeleteBoard = async (boardId: string) => {
    await deleteBoardMutation.mutateAsync(boardId);
  };

  return (
    <BoardContent
      boards={boards}
      loading={isLoading}
      error={error?.message || null}
      addBoard={handleAddBoard}
      updateBoard={handleUpdateBoard}
      deleteBoard={handleDeleteBoard}
    />
  );
};

export default BoardPage;